export var Status = {
  error: 'error',
  loading: 'loading',
  notFound: 'not-found',
  succeeded: 'succeeded'
};
export var DEVICE_TYPE = {
  compare: 'COMPARISON_DEVICES',
  favorite: 'FAVORITE_DEVICES'
};
export var DEVICE_KEY = {
  COMPARISON_DEVICES: 'compare',
  FAVORITE_DEVICES: 'favorite'
};
export var YM_DEVICE_TYPE = {
  COMPARISON_DEVICES: 'compare_ev_',
  FAVORITE_DEVICES: 'wishlist_ev_'
};
export var YM_EVENT_ACTIONS = {
  COMPARISON_DEVICES: {
    add: 'add_to_compare',
    goTo: 'go_to_compare',
    remove: 'remove_from_compare'
  },
  FAVORITE_DEVICES: {
    add: 'add_to_wishlist',
    goTo: 'go_to_wishlist',
    remove: 'remove_from_wishlist'
  }
};
export var LOGO_URL = {
  default: '/customers/products/',
  webview: '/shop/?webview=true'
};
export var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE["fmc"] = "fmc";
  ACCOUNT_TYPE["fttb"] = "fttb";
  ACCOUNT_TYPE["mobile"] = "mobile";
  ACCOUNT_TYPE["none"] = "none";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
export var REQUEST_TIMEOUT = '408';
export var ARIA_ATTR_SEARCH = {
  blockHeading: '{{link}} блока {{block}}',
  historyRequest: 'Поисковый запрос "{{history}}". Чтобы удалить подсказку, нажмите Tab, а затем Ввод.',
  btnDeleteHistory: 'Кнопка удаления истории. Нажмите Ввод, чтобы удалить. Поисковый запрос "{{history}}" из истории.'
};
export var SEARCH_INPUT_ID_MOBILE = 'header_search_input';